import { usePaginatedMasterData } from './usePaginatedMasterData';
import { getDepartments } from '../services/departmentService';
import type {
  DepartmentListFilters,
  DepartmentListItem,
} from '../types/department';
import { activeConfigurationFilters } from '../utils/configurationFilters';

const EMPTY_FILTERS: DepartmentListFilters = activeConfigurationFilters();

export function useDepartments() {
  return usePaginatedMasterData<DepartmentListItem, DepartmentListFilters>({
    getId: item => item.departmentId,
    initialFilters: EMPTY_FILTERS,
    errorMessage: 'Unable to load departments.',
    loadPage: async ({ page, pageSize, search, filters }) =>
      getDepartments({
        page,
        pageSize,
        filters: {
          ...filters,
          search: search || undefined,
        },
      }),
  });
}
